import { render, staticRenderFns } from "./ShopProductVideos.vue?vue&type=template&id=1c3c7774&scoped=true&"
import script from "./ShopProductVideos.vue?vue&type=script&lang=js&"
export * from "./ShopProductVideos.vue?vue&type=script&lang=js&"
import style0 from "./ShopProductVideos.vue?vue&type=style&index=0&id=1c3c7774&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3c7774",
  null
  
)

export default component.exports